__turbopack_context__.v({
  "blok-big-title": "CardGridBlok-module__Ai1K3q__blok-big-title",
  "blok-subtitle": "CardGridBlok-module__Ai1K3q__blok-subtitle",
  "blok-title": "CardGridBlok-module__Ai1K3q__blok-title",
  "card": "CardGridBlok-module__Ai1K3q__card",
  "root": "CardGridBlok-module__Ai1K3q__root",
});
